import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { TwoFAFillIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const KNOWLEDGE_BASE_URL = 'https://knowledge.hubspot.com/chatflows/chat-with-logged-in-visitors';
const IdentifyContactBadge = () => {
  const learnMore = /*#__PURE__*/_jsx(Link, {
    use: "on-bright",
    href: KNOWLEDGE_BASE_URL,
    external: true,
    children: I18n.text('conversations-inbox-ui.crm-integration.IdentifyContactTip.learnMore')
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.verified",
      options: {
        learnMore
      }
    }),
    "data-test-id": "identify-contact-badge-tooltip",
    children: /*#__PURE__*/_jsx(TwoFAFillIcon, {
      size: "400",
      color: "icon-core-subtle",
      "data-test-id": "identify-contact-badge-icon"
    })
  });
};
IdentifyContactBadge.displayName = 'IdentifyContactBadge';
IdentifyContactBadge.propTypes = {};
export default IdentifyContactBadge;